import React from "react";
import "./style.css";
import { imagePath } from "helper";

const CardSliderTalentMobile = (data) => {
  const categoryList = data.expand.category
    .map((item, index) => (
      <div key={index} className="inline-block text-neutral">
        {item.name}
      </div>
    ))
    .reduce((acc, x) => (acc === null ? [x] : [acc, " / ", x]), null);

  return (
    <>
      <div className="w-full relative block h-full">
        <div className="block">
          <div className="block relative w-full aspect-[8/13.9]">
            <img
              src={imagePath(
                data.id,
                data.thumbnail_image,
                data.collectionName
              )}
              alt={data.name}
              className="w-full h-full block z-0 object-cover object-bottom absolute"
              loading="lazy"
            />
          </div>
          <div className="absolute w-full top-0 left-0 z-[1]">
            <div className="overlay-top-card-talent absolute w-full h-full z-0"></div>
            <div className="px-[19px] pt-[16px] pb-[20px] flex justify-between relative z-[1]">
              <div className="">
                <h3 className="font-taviraj text-[32px] leading-[54.59px] text-neutral-50">
                  {data.name}
                </h3>
                <span className="font-medium text-16 leading-[20px] text-tertiary-500">
                  {categoryList}
                </span>
              </div>
              {data?.is_vip && (
                <img
                  src="/images/icon/ic-vip.svg"
                  alt=""
                  className="shrink-0"
                  loading="lazy"
                />
              )}
            </div>
          </div>
        </div>
        <div className="block bg-[linear-gradient(180deg,rgba(170,79,95,0)_0%,#2D1B1E_100%)] py-[27px] px-[5px] absolute w-full bottom-0 left-0">
          <div className="flex justify-center gap-[20px]">
            <div className="flex items-center">
              <img
                src="/images/icon/ic-ig2.svg"
                alt="icon ig"
                className="w-[30px] h-[30px] shrink-0"
                loading="lazy"
              />
              <span className="text-[24px] leading-[30px] block pl-[4px] text-primary-900">
                {data.total_followers_instagram}{" "}
              </span>
            </div>
            <div className="flex items-center">
              <img
                src="/images/icon/ic-tiktok2.svg"
                alt="icon ig"
                className="w-[30px] h-[30px] shrink-0"
                loading="lazy"
              />
              <span className="text-[24px] leading-[30px] block pl-[4px] text-primary-900">
                {data.total_followers_tiktok}{" "}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { CardSliderTalentMobile };
